module.exports = __webpack_public_path__ + "media/images/country_flags/bd-28aa03a64b72730e296b19c84cc9bbf4.png";